const Backbone = require('backbone');

var Collection = new Backbone.Collection();


var update = function() {
	$.ajax({
		url: 'api/index.php',
		type: 'post',
		dataType: 'json',
		data: {
			query: `
				{				  
				  secoes(ids: [1, 2]) {    
				    categorias {
				      ativo
				      subcategorias {
				        ativo
				        produtos {
				          id
				          titulo          
				          mostrar_loja
				          promocao
				          ativo
				          filtros {
				            titulo
				            ativo
				            imagem
				            id
				          }
				          porcoes {
				            id
				            titulo
				            valor
				            valor_promocional
				            estoque
				            calorias
				          }
				        }
				      }
				      produtos {
				        id
				        titulo
				        mostrar_loja
				        promocao
				        ativo
				        filtros {
				          titulo
				          ativo
				          imagem
				          id
				        }
				        porcoes {
				          id
				          titulo
				          valor
				          valor_promocional
				          calorias
				          estoque
				        }
				      }
				    }
				  }
				}
			`
		},
		success: function(resp) {
			var data = resp.data;
			var produtos = [];
			data.secoes.forEach(function(secao) {
				secao.categorias.forEach(function(categoria) {
					categoria.produtos.forEach(function(produto){
						produtos.push(produto);
					});
					categoria.subcategorias.forEach(function(subcategoria){
						subcategoria.produtos.forEach(function(produto){
							produtos.push(produto);
						});
					});
				});
			});
			var collection = new Backbone.Collection(produtos);
			produtos = collection.toJSON();
			Collection.set(produtos);
		},
		error: function() {
			Collection.set([]);
		}
	});
};

update();

module.exports = Collection;


//////////////////
// WEBPACK FOOTER
// ./collections/produtos.js
// module id = 9
// module chunks = 0